export function albumPlaylistSeed(album) {
  return {
    sourceId: album.sourceId,
    albumSource: album.albumSource,
    title: album.title,
    artistName: album.artist?.name,
    artist: album.artist,
    imageUrl: album.imageUrl,
    albumImageUrl: album.imageUrl,
    releaseDate: album.releaseDate,
    contentRating: album.contentRating,
  };
}
export function sameAlbumSource(a, b) {
  return (
    String(a.sourceId) === String(b.sourceId) &&
    String(a.albumSource).toUpperCase() === String(b.albumSource).toUpperCase()
  );
}
export function appendSeedAlbum(items, seed) {
  if (!seed?.sourceId || !seed.albumSource || items.some((item) => sameAlbumSource(item, seed)))
    return items;
  return [...items, seed];
}
